import React from 'react'
import {faPenToSquare, faGear, faTrash} from '@fortawesome/free-solid-svg-icons'
import Tabs from "../Tabs/Tabs";

function BucketsNav({name, location}) {
    return (
        <Tabs>
            <div faIcon={faPenToSquare} exactTo={"/buckets/" + location + "/" + name} label="Properties">
            </div>
            <div faIcon={faGear} exactTo={"/buckets/" + location + "/" + name + "/management"} label="Management">
            </div>
            <div faIcon={faTrash} exactTo={"/buckets/" + location + "/" + name + "/delete"} label="Delete">
            </div>
        </Tabs>
    );
}

export default BucketsNav

